import { Action } from 'redux';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { OpenWorkbookInDesktopDialog } from '../AppActionTypes';

export interface OpenWorkbookInDesktopAction extends Action {
  workbook: IContentInfo;
}

  // TFSID: 1197869
  // TODO: might need to change this in order to find luids for open workbook in desktop dialog props
export function openWorkbookInDesktop(workbook: IContentInfo): OpenWorkbookInDesktopAction {
  return {
    type: OpenWorkbookInDesktopDialog,
    workbook
  };
}